export const mockData = {
  company: {
    name: "Infinitux Solutions",
    slogan: "Innovación que impulsa negocios",
    description: "Somos tu aliado estratégico para el crecimiento y la eficiencia empresarial. Operamos desde dos frentes principales: servicios expertos en gestión corporativa y seguridad social, y el desarrollo de soluciones tecnológicas a medida. Ambos pilares trabajan en sinergia para asegurar tu cumplimiento, optimizar tus operaciones y fortalecer tu presencia digital.",
    mission: "Impulsar la evolución de las empresas a través de soluciones digitales inteligentes y servicios empresariales confiables, optimizando procesos clave y generando valor real para nuestros clientes.",
    vision: "Ser reconocidos como la empresa líder en soluciones integrales de tecnología y gestión empresarial, destacando por la innovación, la excelencia y el compromiso con el éxito de quienes confían en nosotros.",
    values: [
      "Innovación con propósito",
      "Calidad y compromiso ",
      "Transparencia y confianza",
      "Orientación al cliente"
    ]
  },
  
  services: {
    technology: {
      title: "Tecnología",
      description: "Desarrollo y soporte tecnológico integral",
      items: [
        {
          name: "Desarrollo Web",
          description: "Aplicaciones web modernas y responsivas",
          icon: "code"
        },
        {
          name: "Aplicaciones Móviles",
          description: "Apps nativas y multiplataforma",
          icon: "smartphone"
        },
        {
          name: "Soporte Técnico",
          description: "Mantenimiento y soporte 24/7",
          icon: "headphones"
        },
        {
          name: "Consultoría Tecnológica",
          description: "Estrategias digitales personalizadas",
          icon: "lightbulb"
        }
      ]
    },
    business: {
      title: "Servicios Empresariales",
      description: "Gestión y servicios corporativos especializados",
      items: [
        {
          name: "Seguridad Social",
          description: "Afiliaciones y gestión de aportes empresariales con acompañamiento experto",
          icon: "shield"
        },
        {
          name: "Gestión Empresarial",
          description: "Procesos corporativos más eficientes, con apoyo en cumplimiento legal y SST",
          icon: "briefcase"
        },
        {
          name: "Recobros Empresariales",
          description: "Administración y recuperación de cartera con procesos especializados",
          icon: "dollarsign"
        },
        {
          name: "Consultoría Legal",
          description: "Soporte legal estratégico para garantizar el cumplimiento y optimizar la gestión en seguridad social",
          icon: "scale"
        }
      ]
    }
  },

  products: [
    {
      id: 1,
      name: "MiPila",
      description: "Plataforma integral de seguridad social que simplifica la gestión de afiliaciones, aportes y trámites empresariales con tecnología de vanguardia.",
      features: [
        "Gestión centralizada y eficiente",
        "Administración versátil de datos",
        "Reportes detallados",
        "Datos consistentes y actualizados"
      ],
      category: "Seguridad Social",
      status: "Disponible",
      url: "https://mipila.infinitux.co"
    },
    {
      id: 2,
      name: "Recobra360",
      description: "Aplicación especializada en el recobro de prestaciones económicas, con control total y trazabilidad de los trámites ante las entidades correspondientes.",
      features: [
        "Automatización de procesos de recobro",
        "Dashboard analítico avanzado",
        "Gestión centralizada de carteras",
        "Notificaciones inteligentes"
      ],
      category: "Gestión Empresarial",
      status: "Disponible"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "María González",
      position: "Gerente General",
      company: "TechCorp SA",
      content: "Infinitux Solutions transformó completamente nuestra gestión empresarial. La implementación de MiPila redujo nuestros tiempos administrativos en un 60%.",
      rating: 5
    },
    {
      id: 2,
      name: "Carlos Rodríguez",
      position: "Director de IT",
      company: "Innovate Group",
      content: "El equipo de Infinitux desarrolló nuestra plataforma web con un nivel de profesionalismo excepcional. Altamente recomendados.",
      rating: 5
    },
    {
      id: 3,
      name: "Ana Martínez",
      position: "CEO",
      company: "StartUp Digital",
      content: "Recobra360 revolucionó nuestro proceso de cobranza. Ahora tenemos visibilidad completa y mejores resultados en recuperación de cartera.",
      rating: 5
    }
  ],

  contact: {
    email: "infinituxservices@gmail.com",
    phone: "+57 321 904 3880",
    socialMedia: {
      linkedin: "https://linkedin.com/company/infinitux-solutions",
      facebook: "https://facebook.com/infinituxsolutions",
      instagram: "https://instagram.com/infinituxsolutions",
      twitter: "https://twitter.com/infinituxsol"
    }
  },

  stats: [
    { label: "Clientes Satisfechos", value: "150+", icon: "users" },
    { label: "Proyectos Completados", value: "200+", icon: "checkcircle" },
    { label: "Años de Experiencia", value: "8+", icon: "calendar" },
    { label: "Tecnologías Dominadas", value: "25+", icon: "code" }
  ]
};